import React, { useContext } from 'react';
import '../css/swipeable-flows.css';
import { ShareLinkContext } from '../share/ShareLinkContext';
import ShareModal from '../share/ShareModal';

function SwipeableFlowsContainer({ children }) {
    const { showShareModal, shareLink } = useContext(ShareLinkContext);

    return (
        <>
            {showShareModal && <ShareModal shareUrl={shareLink} />}
            <div className='swipeable-container'>
                <div className='swipeable-container-2'> {/* Don't know why, but this is needed to make the flows fit properly on smaller screens */}
                    {children}
                </div>
            </div>
        </>
    )
}

export default SwipeableFlowsContainer